import { FixedSchedule, FlexibleSchedule, ScheduleType } from '@flyblack/common/domains';

export const getScheduleDeparture = (schedule: FixedSchedule | FlexibleSchedule) => {
  return schedule.type === ScheduleType.Fixed ? schedule.departsAt : schedule.departureInterval.start;
};

export const getScheduleArrival = (schedule: FixedSchedule | FlexibleSchedule) => {
  return schedule.type === ScheduleType.Fixed ? schedule.arrivesAt : schedule.arrivalInterval.start;
};
